import Lan from "./lan";


export default Lan;